import { bookingMutationsKeys } from "../mutation_keys";

export const bookingPartUpdateKeys = {
  update: (id: number) => [...bookingMutationsKeys.update(id), "part"]
};
